import axios from 'axios';
import log from '../../../logger';

/**
 * The link picker's data layer.
 *
 * SSO settings are NOT here. They come from the browser config in redux
 * (`selectSsoLinksConfig`), which the server projects to exactly `{enabled, siteName}`. An
 * earlier cut of this module fetched `/plugins/plugins.json` per dialog open and read
 * `plugin.ssoLinks` wholesale, which duplicated that source of truth.
 *
 * `getNavTypes` and `getNavOptionsForType` are served by the `wysiwyg` plugin
 * (`plugins/wysiwyg/cms/server/wysiwygApi.js`), which asks every loaded plugin what it can
 * be linked to. **That server half is staying**; only the Angular browser half moved to
 * React, so these are the same two endpoints the old `internalLinkService` called.
 */
const BASE_URL = '/plugins/wysiwyg/api/';

/** Every link type the tenant's loaded plugins offer. */
export async function getNavTypes() {
  try {
    const { data } = await axios.get(`${BASE_URL}getNavTypes`);
    return data?.navTypes || [];
  } catch (error) {
    log.error('error in getNavTypes', error);
    throw error;
  }
}

/**
 * The targets for one link type.
 *
 * `selectionContext` drives the second-level selectors: picking a collection, say, then
 * asks for that collection's items.
 */
export async function getNavOptionsForType(navType, selectionContext) {
  try {
    const { data } = await axios.get(`${BASE_URL}getNavOptionsForType`, {
      params: { navType, ...(selectionContext ? { selectionContext } : {}) },
    });
    return data?.navOptions || [];
  } catch (error) {
    log.error('error in getNavOptionsForType', error);
    throw error;
  }
}
